module.exports = __webpack_public_path__ + "img/a9936a369e82e0c6c42112674a5220e8_fullsize.a9936a36.jpg";